import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_2 = {
  class: "W-100 D-Flex FlexWrap P-Rel",
  style: {"z-index":"500","gap":"1em"}
}
const _hoisted_3 = { class: "F-Bold M-Auto" }
const _hoisted_4 = {
  key: 0,
  id: "TableToPrint",
  class: "ReportTableContainer W-100",
  style: {}
}
const _hoisted_5 = { class: "F1_5em P1_75em" }
const _hoisted_6 = {
  class: "F1_5em",
  style: {"justify-content":"flex-end","align-items":"flex-end","display":"flex","flex-direction":"column"}
}
const _hoisted_7 = { class: "F1_25em F-Bold" }
const _hoisted_8 = { class: "F_85em" }
const _hoisted_9 = { class: "F_85em" }
const _hoisted_10 = { class: "F_85em" }
const _hoisted_11 = {
  key: 0,
  class: "F_85em"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "CookiesBoxPrintInput F1_5em P1em",
  contenteditable: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesTable = _resolveComponent("CookiesTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printIT())),
        class: "Shadow2 PrintButton D-Flex RowMargin NOPRINT M-Auto",
        style: {"height":"2em"}
      }, [
        _createVNode(_component_CookiesIcon, {
          class: "V-Auto",
          style: {"width":"1.1em","height":"1.7em","margin":"0 0.3em"},
          ID: 'Printer'
        }),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Translate('Print')), 1)
      ]),
      _createVNode(_component_CookiesDropInputObject, {
        RowHeight: '3em',
        Name: _ctx.Translate('Customer'),
        CookiesInvalidInput: !(_ctx.MEMRead('R_Sales_Customers') && _ctx.MEMRead('R_Sales_Customers') !== ''),
        Options: _ctx.Customers,
        Selectors: [['Name'], ['Serial']],
        Res: 'R_Sales_Customers'
      }, null, 8, ["Name", "CookiesInvalidInput", "Options"])
    ]),
    (_ctx.MEMRead('R_Sales_Customers') && _ctx.SelectedCustomer && _ctx.SelectedCustomer.Name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.FileName), 1),
          _createVNode(_component_CookiesTable, {
            class: "W-100",
            Loading: _ctx.Loading.length > 0,
            CookiesData: _ctx.FilteredData,
            TableSettings: _ctx.TableSettings
          }, null, 8, ["Loading", "CookiesData", "TableSettings"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.Translate('Balance')) + ":", 1),
              _createTextVNode(),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.DecimalFixer(_ctx.TotalBalance)), 1),
              _createTextVNode(),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.PriceUnit), 1),
              _createTextVNode(),
              (_ctx.TotalBalance !== 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(_ctx.TotalBalance > 0 ? _ctx.Translate('For him') : _ctx.Translate('On him')) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_12
        ]))
      : _createCommentVNode("", true)
  ], 64))
}